<template>
  <KeyValue
    :caption="caption">
    <div
      class="flex gap-2"
      @click="$emit('click')">
      <span
        class="my-auto">
        {{ value }}
      </span>
      <TooltipedBtn
        class="my-auto"
        icon="copy"
        small-btn
        :text="$t('Common.Copy')"
        @click.stop="copyValues(value)"/>
    </div>
  </KeyValue>
</template>
<script>
import KeyValue from 'components/common/KeyValue.vue'
import TooltipedBtn from 'components/common/elements/TooltipedBtn.vue'

export default {
  name: 'keyValueWithCopy',
  data() {
    return {}
  },
  methods: {
    copyValues(value) {
      navigator.clipboard.writeText(value)
      this.$notice.info({
        title: this.$t('Common.Copy'),
        message: this.$t('Tenders.Copied'),
        duration: 10
      })
    },
  },
  components: {
    KeyValue,
    TooltipedBtn
  },
  props: {
    caption: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: ''
    }
  }
}
</script>
